const checkoutTrackingMetaCreator = ({ productData }) => {
  return {
    productId: productData?.id,
  }
}

export default checkoutTrackingMetaCreator
